/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleResponse } from './RoleResponse';
import {
    RoleResponseFromJSON,
    RoleResponseFromJSONTyped,
    RoleResponseToJSON,
    RoleResponseToJSONTyped,
} from './RoleResponse';
import type { PermissionResponse } from './PermissionResponse';
import {
    PermissionResponseFromJSON,
    PermissionResponseFromJSONTyped,
    PermissionResponseToJSON,
    PermissionResponseToJSONTyped,
} from './PermissionResponse';

/**
 * 
 * @export
 * @interface EmployerDependentAccessesResponse
 */
export interface EmployerDependentAccessesResponse {
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof EmployerDependentAccessesResponse
     */
    roles?: Array<RoleResponse> | null;
    /**
     * 
     * @type {Array<PermissionResponse>}
     * @memberof EmployerDependentAccessesResponse
     */
    permissions?: Array<PermissionResponse> | null;
}

/**
 * Check if a given object implements the EmployerDependentAccessesResponse interface.
 */
export function instanceOfEmployerDependentAccessesResponse(value: object): value is EmployerDependentAccessesResponse {
    return true;
}

export function EmployerDependentAccessesResponseFromJSON(json: any): EmployerDependentAccessesResponse {
    return EmployerDependentAccessesResponseFromJSONTyped(json, false);
}

export function EmployerDependentAccessesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployerDependentAccessesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': json['roles'] === undefined ? undefined : json['roles'] === null ? null : ((json['roles'] as Array<any>).map(RoleResponseFromJSON)),
        'permissions': json['permissions'] === undefined ? undefined : json['permissions'] === null ? null : ((json['permissions'] as Array<any>).map(PermissionResponseFromJSON)),
    };
}

export function EmployerDependentAccessesResponseToJSON(json: any): EmployerDependentAccessesResponse {
    return EmployerDependentAccessesResponseToJSONTyped(json, false);
}

export function EmployerDependentAccessesResponseToJSONTyped(value?: EmployerDependentAccessesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleResponseToJSON)),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(PermissionResponseToJSON)),
    };
}

